const currencyOptions = {
  minimumFractionDigits: 0,
};

export const formatFinancialValue = (num?: number | null): string => {
  const formattedNumber = num ? +num?.toFixed(2) : '';
  return num === 0 ? '0' : formattedNumber.toLocaleString('en-US', currencyOptions);
};
